"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[35244],{

/***/ 35244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home_page_Reports; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./src/features/home-page/styled.ts
var styled = __webpack_require__(24529);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/home-page/Reports/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  .big,\n  .small {\n    width: 100%;\n  }\n\n  @media ",
        " {\n    align-items: center;\n    flex-direction: row;\n\n    .big {\n      padding-right: 50px;\n      width: calc(100% - 400px);\n    }\n\n    .small {\n      padding-left: 50px;\n      width: 400px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n\n  @media ",
        " {\n    font-size: 36px;\n    margin: unset;\n    text-align: left;\n  }\n  @media ",
        " {\n    font-size: 36px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  margin-left: auto;\n  margin-right: auto;\n\n  @media ",
        " {\n    margin-top: 5vh;\n    margin-left: unset;\n    margin-right: unset;\n    text-align: left;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var ContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3ca73658-0"
})(_templateObject(), device/* default.laptop */.Z.laptop);
var Title = (0,styled_components_browser_esm/* default */.ZP)(styled/* SectionTitle */.NZ).withConfig({
    componentId: "sc-3ca73658-1"
})(_templateObject1(), device/* default.laptop */.Z.laptop, device/* default.laptopL */.Z.laptopL);
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(styled/* SectionSubtitle */.Vq).withConfig({
    componentId: "sc-3ca73658-2"
})(_templateObject2(), device/* default.laptop */.Z.laptop);


// EXTERNAL MODULE: ./src/features/home-page/uikit/index.ts + 6 modules
var uikit = __webpack_require__(31805);
;// CONCATENATED MODULE: ./src/features/home-page/Reports/index.tsx









function Reports() {
    var ref = (0,react.useState)(false), viewed = ref[0], setViewed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            top: 140,
            bottom: 140
        },
        partialVisibility: true,
        onChange: function(v) {
            return setViewed(function(s) {
                return s || v;
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Wrapper */.im, {
            align: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "big",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit/* BrowserBox */.AY, {
                            image: "".concat(app/* assetPrefix */.Vc, "/images/sbnews2.webp")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        className: "small",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                className: (0,clsx_m/* default */.Z)("fadeInLeftX", viewed && "fadeInLeft"),
                                children: "Berita & Laporan dari Sumber Terpercaya"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                className: (0,clsx_m/* default */.Z)("fadeInLeftX2", viewed && "fadeInLeft2"),
                                children: "Satu tempat yang praktis untuk baca berita dari berbagai sumber."
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var home_page_Reports = (Reports);


/***/ }),

/***/ 24529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NZ": function() { return /* binding */ SectionTitle; },
/* harmony export */   "Vq": function() { return /* binding */ SectionSubtitle; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74575);
/* harmony import */ var _keyframes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16681);
/* eslint-disable indent */ /* eslint-disable space-infix-ops */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 50px 25px;\n  width: 100%;\n  max-width: 1300px;\n\n  @media ",
        " {\n    padding: 50px 30px;\n  }\n\n  @media ",
        " {\n    padding: 50px 0;\n    width: calc(100% - 150px);\n  }\n\n  // animations\n  .scaleUpX {\n    transform: scale(0.9);\n  }\n\n  .fadeInRightX,\n  .fromRightX,\n  .fadeInLeftlongX,\n  .fadeInLeftBorderX,\n  .fadeInLeftX2,\n  .fadeInLeftX,\n  .fadeInX,\n  .fadeInTopX,\n  .fadeInDownX,\n  .scaleUpX {\n    opacity: 0;\n  }\n\n  .fadeInLeftBorderX.on,\n  .fadeInLeftX.on,\n  .fadeInX.on {\n    opacity: 1;\n  }\n\n  .fadeIn {\n    animation-duration: 1s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fromRight {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInRight {\n    animation-duration: 1s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInLeft {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInLeft2 {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    animation-delay: 0.3s;\n  }\n\n  .fadeInTopX {\n  }\n\n  .fadeInTop {\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    transform: translate3d(0, -50px, 0);\n  }\n\n  .fadeInDown {\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    transform: translate3d(0, -50px, 0);\n  }\n\n  .fromRightP:nth-child(1) .fromRight {\n    animation-delay: 0.2s;\n  }\n\n  .fromRightP:nth-child(2) .fromRight {\n    animation-delay: 0.35s;\n  }\n\n  .fromRightP:nth-child(3) .fromRight {\n    animation-delay: 0.5s;\n  }\n\n  .fromRightP:nth-child(4) .fromRight {\n    animation-delay: 0.65s;\n  }\n\n  .fromRightP:nth-child(5) .fromRight {\n    animation-delay: 0.8s;\n  }\n\n  .fromRightP:nth-child(6) .fromRight {\n    animation-delay: 0.95s;\n  }\n\n  .scaleUp {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 36px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 6.5vh;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 17px;\n  margin-top: 5vh;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n\n  @media ",
        " {\n    font-size: 19px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    m: "auto",
    as: "section"
}).withConfig({
    componentId: "sc-896b5acc-0"
})(_templateObject(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeIn */ .Ji, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fromRight */ .hb, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInRight */ .ER, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInLeft */ .O2, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInLeft */ .O2, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInTop */ .E_, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInDown */ .d7, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .scaleUp */ .wK);
var SectionTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "h1",
    family: "bold",
    height: 1,
    m: "0px"
}).withConfig({
    componentId: "sc-896b5acc-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop);
var SectionSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    family: "light",
    height: 1.5
}).withConfig({
    componentId: "sc-896b5acc-2"
})(_templateObject2(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop);



/***/ }),

/***/ 31805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AY": function() { return /* reexport */ uikit_BrowserBox; },
  "s_": function() { return /* reexport */ uikit_Panel; },
  "sV": function() { return /* reexport */ uikit_PhonePreview; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/home-page/uikit/BrowserBox/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  box-shadow: 0 0 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);\n  margin: 20px 0;\n  max-width: 840px;\n  overflow: hidden;\n  padding: 8px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px 4px 0 0;\n  height: 24px;\n  padding: 6px 3px;\n\n  .browser-bullet {\n    background: #2f8ef7;\n    border-radius: 10px;\n    float: left;\n    height: 7px;\n    margin-left: 7px;\n    opacity: 0.8;\n    vertical-align: middle;\n    width: 7px;\n\n    :nth-child(1) {\n      background: #fc605c;\n    }\n    :nth-child(2) {\n      background: #fdbc40;\n    }\n    :nth-child(3) {\n      background: #34c84a;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        " no-repeat center top / 100% auto;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgb(0 0 0 / 10%);\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n\n  img {\n    width: 98%;\n    opacity: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var BoxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b3c12d-0"
})(_templateObject(), color/* default.component */.Z.component);
var TabToolTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b3c12d-1"
})(_templateObject1());
var BrowserContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b3c12d-2"
})(_templateObject2(), color/* default.light */.Z.light);


;// CONCATENATED MODULE: ./src/features/home-page/uikit/BrowserBox/index.tsx



function BrowserBox(param) {
    var image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToolTop, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "browser-bullet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "browser-bullet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "browser-bullet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserContent, {
                style: {
                    backgroundImage: "url(".concat(image, ")")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: image,
                    alt: "browser preview"
                })
            })
        ]
    });
}
/* harmony default export */ var uikit_BrowserBox = (BrowserBox);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/features/home-page/uikit/Panel/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: solid ",
        ";\n  border-width: 1px;\n  margin-bottom: 10px;\n  padding: 10px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media ",
        " {\n    border-width: 2px;\n    padding: 10px 20px;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  b {\n    font-family: var(--bold-font);\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border: solid 1px ",
        ";\n  border-radius: 50%;\n  display: flex;\n  flex-shrink: 0;\n  height: 30px;\n  margin-right: 10px;\n  justify-content: center;\n  width: 30px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c1289ee-0"
})(styled_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, device/* default.tablet */.Z.tablet);
var TextContent = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "15px",
    mb: "5px"
}).withConfig({
    componentId: "sc-c1289ee-1"
})(styled_templateObject1());
var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-c1289ee-2"
})(styled_templateObject2(), color/* default.midgray */.Z.midgray);


;// CONCATENATED MODULE: ./src/features/home-page/uikit/Panel/index.tsx









function Panel(_param) {
    var symbol = _param.symbol, time = _param.time, description = _param.description, props = (0,_object_without_properties/* default */.Z)(_param, [
        "symbol",
        "time",
        "description"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                    className: "icon-avatar_report"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: symbol
                            }),
                            " ",
                            description,
                            " [",
                            symbol,
                            "]"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: color/* default.midgray */.Z.midgray,
                        size: "12px",
                        children: time
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var uikit_Panel = (Panel);

;// CONCATENATED MODULE: ./src/features/home-page/uikit/PhonePreview/styled.ts

function PhonePreview_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px;\n  position: relative;\n\n  @media ",
        " {\n    margin-bottom: 50px;\n    padding: 0;\n  }\n"
    ]);
    PhonePreview_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PhonePreview_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  @media ",
        " {\n    width: 300px;\n  }\n\n  @media ",
        " {\n    width: 350px;\n  }\n"
    ]);
    PhonePreview_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PhonePreview_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: block;\n    position: absolute;\n    width: 260px;\n    transform: translateY(-1px);\n  }\n\n  @media ",
        " {\n    width: 303px;\n  }\n"
    ]);
    PhonePreview_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  transform: translateY(-1px);\n  width: 70%;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var styled_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-2777b227-0"
})(PhonePreview_styled_templateObject(), device/* default.tablet */.Z.tablet);
var PhoneFrame = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-2777b227-1"
})(PhonePreview_styled_templateObject1(), device/* default.tablet */.Z.tablet, device/* default.laptopL */.Z.laptopL);
var Video = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    componentId: "sc-2777b227-2"
})(PhonePreview_styled_templateObject2(), device/* default.tablet */.Z.tablet, device/* default.laptopL */.Z.laptopL);
var FallbackImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-2777b227-3"
})(_templateObject3(), device/* default.tablet */.Z.tablet);


;// CONCATENATED MODULE: ./src/features/home-page/uikit/PhonePreview/index.tsx


var PhonePreview = function(props) {
    var videoUrl = props.videoUrl, fallbackImage = props.fallbackImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneFrame, {
                alt: "iPhone frame",
                src: "/images/iphone6.webp"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                id: "video",
                autoPlay: true,
                loop: true,
                muted: true,
                playsInline: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: videoUrl
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FallbackImage, {
                className: "videofallback",
                src: fallbackImage,
                alt: "Your browser does not support the video"
            })
        ]
    });
};
/* harmony default export */ var uikit_PhonePreview = (PhonePreview);

;// CONCATENATED MODULE: ./src/features/home-page/uikit/index.ts





/***/ })

}]);